export default "__VITE_ASSET__b04e9d05__"